module.exports = __webpack_public_path__ + "static/hero-bg-desktop-de-c9b856d892db002768275a0c83865403.jpg";